import { render, staticRenderFns } from "./location-chart.vue?vue&type=template&id=02c42460"
import script from "./location-chart.vue?vue&type=script&lang=js"
export * from "./location-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports